import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import type { FBAuthCustomClaimsUser } from '@/shared/typings/types/firebase';

type EnvState = {
  shop: string;
  emulating: string | null;
  isAdmin: boolean;
  hasAuthenticated: boolean;
  user: FBAuthCustomClaimsUser | null;
  isEmbedded: boolean;
}

const initialState: EnvState = {
  shop: shopify?.config?.shop || '',
  emulating: null,
  isAdmin: false,
  hasAuthenticated: false,
  user: null,
  isEmbedded: window.top !== window.self,
};

export const envSlice = createSlice({
  name: 'env',
  initialState,
  reducers: {
    setShop: (state, req) => {
      const { payload }: PayloadAction<string> = req;
      console.log('SET SHOP', payload);
      console.log(req);
      state.shop = payload;
    },
    setEmulating: (state, { payload }: PayloadAction<string | null>) => {
      state.emulating = payload;
    },
    setIsAdmin: (state, { payload }: PayloadAction<boolean>) => {
      state.isAdmin = payload;
    },
    setHasAuthenticated: (state, { payload }: PayloadAction<boolean>) => {
      state.hasAuthenticated = payload;
    },
    setUser: (state, { payload }: PayloadAction<FBAuthCustomClaimsUser | null>) => {
      state.user = payload;
    },
    setEmbedded: (state, { payload }: PayloadAction<boolean>) => {
      state.isEmbedded = payload;
    }
  },
});

export const {
  setShop,
  setEmulating,
  setIsAdmin,
  setHasAuthenticated,
  setUser,
  setEmbedded,
} = envSlice.actions;

export const getShop = (state: RootState) => state.env.shop;
export const getEmulating = (state: RootState) => state.env.emulating;
export const getIsEmulating = (state: RootState) => !!state.env.emulating;
export const getIsAdmin = (state: RootState) => state.env.isAdmin;
export const getAppHasAuthenticated = (state: RootState) => state.env.hasAuthenticated;
export const getUser = (state: RootState) => state.env.user;
export const getRequestShop = (state: RootState) => state.env.emulating || state.env.shop;

export default envSlice.reducer;
